import { type FunctionComponent } from "react";

import eTakeoffLogo from "images/Common/eTakeoff_logo.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedEtakeoff: FunctionComponent<IBTIconProps> = (baseProps) => {
    return (
        <img alt="" src={eTakeoffLogo} style={baseProps.style} className={baseProps.className} />
    );
};
